import { FC, useEffect, useState, Suspense } from 'react';
import { Layout, theme as antTheme } from 'antd';
import MenuComponent from './menu';
import HeaderComponent from './header';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';


const { Sider, Content } = Layout;
const WIDTH = 992;

const LayoutPage: FC = () => {
    const location = useLocation();
    const [openKey, setOpenkey] = useState<string>();
    const [selectedKey, setSelectedKey] = useState<string>(location.pathname);
    //const [menuList, setMenuList] = useState<MenuList>([]);
    const token = antTheme.useToken();
    const [collapsed, setCollapsed] = useState(false);
    const dispatch = useDispatch();
    interface MenuItem {
        code: string;
        label: string;
        icon?: string;
        path: string;
        children?: MenuItem[];
    }
    const menus = [
        {
            'code': '1',
            'label': 'Users',
            'icon': 'account',
            'path': '/users'
        },
        {
            'code': '2',
            'label': 'Product Categories',
            'icon': 'documentation',
            'path': '/category'
        },
        {
            'code': '3',
            'label': 'Body Shapes',
            'icon': 'documentation',
            'path': '/bodyshape'
        },
        {
            'code': '4',
            'label': 'Body Sizes',
            'icon': 'documentation',
            'path': '/bodysize'
        },
        {
            'code': '5',
            'label': 'Orifice Sizes(Valve)',
            'icon': 'documentation',
            'path': '/orificeSize'
        },
        {
            'code': '6',
            'label': 'Connection Sizes',
            'icon': 'documentation',
            'path': '/fittingSize'
        },
        {
            'code': '7',
            'label': 'Connection Types',
            'icon': 'documentation',
            'path': '/fittingtype'
        },
        {
            'code': '8',
            'label': 'Product Types',
            'icon': 'documentation',
            'path': '/productType'
        },
        {
            'code': '9',
            'label': 'Nuts',
            'icon': 'documentation',
            'path': '/nut'
        },
        {
            'code': '10',
            'label': 'Nuts Material',
            'icon': 'documentation',
            'path': '/nutMaterial'
        },
        {
            'code': '11',
            'label': 'Nuts Shape',
            'icon': 'documentation',
            'path': '/nutShape'
        },
        {
            'code': '14',
            'label': 'Connection Conversion',
            'icon': 'documentation',
            'path': '/connectionConversion'
        },
        {
            'code': '12',
            'label': 'Data Version',
            'icon': 'documentation',
            'path': '/dataVersion'
        },
        {
            'code': '13',
            'label': 'App Update Settings',
            'icon': 'documentation',
            'path': '/updateSetting'
        }

    ]



    useEffect(() => {
        setSelectedKey(location.pathname);
    }, [location.pathname]);

    const toggle = () => {
        setCollapsed(!collapsed)
    };



    useEffect(() => {
        window.onresize = () => {
            const rect = document.body.getBoundingClientRect();
            const needCollapse = rect.width < WIDTH;

        };
    }, [dispatch]);



    return (
        <Layout className="layout-page">
            <HeaderComponent collapsed={collapsed} toggle={toggle} />
            <Layout className='sub-layout'>
                <Sider
                    className="layout-page-sider"
                    trigger={null}
                    collapsible
                    style={{ backgroundColor: token.token.colorBgContainer }}
                    collapsedWidth={80}
                    collapsed={collapsed}
                    breakpoint="md"
                >
                    <MenuComponent
                        menuList={menus}
                        openKey={openKey}
                        onChangeOpenKey={k => setOpenkey(k)}
                        selectedKey={selectedKey}
                        onChangeSelectedKey={k => setSelectedKey(k)}
                    />
                </Sider>
                <Content className="layout-page-content">
                    <Suspense fallback={null}>
                        <Outlet />
                    </Suspense>
                </Content>
            </Layout>
        </Layout>
    );
};

export default LayoutPage;

function useSelector(arg0: (state: any) => any): { device: any; collapsed: any; newUser: any; } {
    throw new Error('Function not implemented.');
}


function useGuide(): { driverStart: any; } {
    throw new Error('Function not implemented.');
}


function getFirstPathCode(pathname: string) {
    throw new Error('Function not implemented.');
}


function setUserItem(arg0: { collapsed: boolean; }): any {
    throw new Error('Function not implemented.');
}


function getMenuList(): { status: any; result: any; } | PromiseLike<{ status: any; result: any; }> {
    throw new Error('Function not implemented.');
}

